import {Action} from "redux";
import {Pager} from "../../domain/model/common";
import { ISkillTagActionCreator } from '../action/skill_tag_action';
import { 
    GetMultiSkillTagListRequest, 
    GetOccupationSkillTagListRequest, 
    GetSingleSkillTagListRequest} from "../request/skill_tag_request";

interface ISkillTagDispatcher {
    single_getAll(pager: Pager): void;

    multi_getAll(pager: Pager): void;
}
class Dispatcher implements ISkillTagDispatcher {

    constructor(private dispatch: (action: Action) => void,
                private actionCreator: ISkillTagActionCreator) {
    };

    // single
    public single_getAll = (item: GetSingleSkillTagListRequest): void => {
        this.dispatch(this.actionCreator.requestGetSingleSkillTagListAction(item));
    }


    // multi
    public multi_getAll = (item: GetMultiSkillTagListRequest): void => {
        this.dispatch(this.actionCreator.requestGetMultiSkillTagListAction(item));
    }

    // occupation
    public occupation_getAll = (item: GetOccupationSkillTagListRequest): void => {
        this.dispatch(this.actionCreator.requestGetOccupationSkillTagListAction(item));
    }

}

const createSkillTagDispatcher = (dispatch: (action: Action) => void, actionCreator: ISkillTagActionCreator): ISkillTagDispatcher => {
    return new Dispatcher(dispatch, actionCreator);
};

export {
    ISkillTagDispatcher, 
    createSkillTagDispatcher, 
};



// WEBPACK FOOTER //
// ./src/presentation/dispatcher/skill_tag_dispatcher.ts